// ======================================================================
// File Name       : course
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { hasProperty, MIN_DATE, MAX_DATE, MIN_DATE_NO_SECOND, MAX_DATE_NO_SECOND } from '../utils';
import * as courseUtils from '../utils/CourseUtils';
import * as ActionTypes from '../constants/actionTypes/course';
import { PUBLIC_PERIOD_TYPE,
         END_CONDITION_TYPE_FOR_COURSE,
         CHOSEN_THUMBNAIL,
         COURSE_GROUP_RELATION_TYPE,
         CERTIFICATE_USE_FLAG,
        } from '../constants/CourseConstants';
import { USER_TYPE } from '../constants/UserConstants';
import { MODE, PUBLIC } from '../constants';

const INITIAL_COURSE = {
  courseSecernId: null,
  courseName: '',
  description: '',
  publicStatus: PUBLIC,
  publicPeriodFrom: null,
  publicPeriodTo: null,
  endConditionTypeForCourse: END_CONDITION_TYPE_FOR_COURSE.NONE,
  imageFileSelectType: CHOSEN_THUMBNAIL.DEFAULT,
  progressRatioForCourseEnd: 0, // Step 10.2.0
  itemListForCourseEnd: [],
  completionFlag: CERTIFICATE_USE_FLAG.NO_USE,
  selectedItemList: [],
};

const INITIAL_STATE = {
  courses: {
    bySecernId: {},
    allSecernIds: [],
    searchUserCondition: { userType: USER_TYPE.STUDENT, userAttributeKeyNum: 1 },
  },

  courseRelations: {
    recordNum: 0,
    bySecernId: {
      // user_secern_id: {}
    },
    allSecernIds: [],
  },

  searchUserCondition: { userType: USER_TYPE.STUDENT, userAttributeKeyNum: 1 },
  searchUserResult: {
    startPosition: 0,
    searched: false,
    recordNum: 0,
    bySecernId: {},
    allSecernIds: [],
  },

  editType: MODE.EDIT_MODE,

  editingUser: {},

  userList: {},

  editingCourse: {
    publicStatus: PUBLIC,
  },

  checkedUser: {
    bySecernId: {},
    allSecernIds: [],
  },

  checkedUserOnPage: {
    bySecernId: {},
    allSecernIds: [],
  },

  childItemSercernIdList: [],
  selectedCourseGroupRelationList: [],
  groupCourseRelationList: [],
  recordNumGroupCourseRelation: 0,//STEP10.0.0
};

export default function course(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ActionTypes.COURSE_INIT_DATA_FOR_DETAIL_EDIT_CONFIRM_DIALOG:
      return initDataForDetailEditConfirmDialog(state, action);

    case ActionTypes.COURSE_INIT_DATA_FOR_REGISTER_DIALOG:
      return initDataForRegisterDialog(state, action);

    case ActionTypes.COURSE_RECEIVE_COURSE_LIST:
      return receiveCourseList(state, action);

    case ActionTypes.COURSE_RECEIVE_COURSE_RELATION:
      return receiveCourseRelation(state, action);

    case ActionTypes.COURSE_INPUT_CHANGE:
      return changeEditingData(state, action);

    case ActionTypes.COURSE_RECEIVE_SEARCH_CONDITION:
      return receiveSearchUserCondition(state, action);

    case ActionTypes.COURSE_RECEIVE_USER_SEARCH_RESUTL:
      return receiveUserSearchUserResult(state, action);

    case ActionTypes.COURSE_RECEIVE_USER_LIST:
      return receiveUserList(state, action);

    case ActionTypes.COURSE_ADD_REMOVE_USER:
      return addRemoveUser(state, action);

    case ActionTypes.COURSE_ADD_REMOVE_ALL_USER:
      return addRemoveAllUser(state);

    case ActionTypes.COURSE_ADD_USER_RELATION:
      return addUserRelation(state, action);

    case ActionTypes.COURSE_REMOVE_USER_RELATION:
      return removeUserRelation(state, action);

    case ActionTypes.COURSE_REMOVE_ALL_USER_RELATION:
      return removeAllUserRelation(state, action);

    case ActionTypes.COURSE_EDIT_PERIOD_TIME:
      return editPeriodTime(state, action);

    case ActionTypes.COURSE_CHANGE_EDIT_TYPE:
      return changeEditType(state, action);

    case ActionTypes.COURSE_RESET_INIT_DATA:
      return resetInitData(state);

    case ActionTypes.COURSE_CHANGE_DATA:
      return changeData(state);

    case ActionTypes.COURSE_GET_THUMBNAIL_DEFAULT:
      return getThumbnailDefault(state, action);

    case ActionTypes.GET_USER_COURSE_RELATION:
      return getUserCourseRelation(state, action);

    case ActionTypes.COURSE_ADD_GROUP_RELATION:
      return addCourseGroupRelation(state, action);

    case ActionTypes.COURSE_DEL_GROUP_RELATION:
      return removeCourseGroupRelation(state, action);

    case ActionTypes.COURSE_DEL_ALL_GROUP_RELATION:
      return removeAllCourseGroupRelation(state, action);

    case ActionTypes.COURSE_EDIT_GROUP_PERIOD_TIME:
      return editGroupPeriodTime(state, action);

    case ActionTypes.GET_GROUP_COURSE_RELATION:
      return receiveGroupCourseSearchResult(state, action);

    // Step 10.2.0 START
    case ActionTypes.COURSE_SAVE_DETAIL_SETTING_STATE:
      return saveDetailSettingState(state, action);
    // Step 10.2.0 END

    default:
      return state;
  }
}

function initDataForDetailEditConfirmDialog(state, action) {
  const { courseSecernId, childItemSercernIdList } = action;
  const { courses: { bySecernId }, courseRelations, userList, selectedCourseGroupRelationList } = state;
  const { detailSettingExpanded, userAttributeExpanded } = INITIAL_STATE;
  if (bySecernId && bySecernId[courseSecernId]) {
    const { publicPeriodFrom, publicPeriodTo, itemListForCourseEnd } = bySecernId[courseSecernId];
    const { noLimitFrom, noLimitTo } = courseUtils.getLimitationInfoPublicPeriod(
      publicPeriodFrom,
      publicPeriodTo,
    );
    const editingCourse = {
      ...state.editingCourse,
      ...bySecernId[courseSecernId],
      limitPublicPeriod: noLimitTo && noLimitFrom ? PUBLIC_PERIOD_TYPE.NO_LIMIT : PUBLIC_PERIOD_TYPE.LIMIT,
      thumbnailUrl: bySecernId[courseSecernId].thumbnailUrl,
      imageFileSelectType: CHOSEN_THUMBNAIL.NOTHING,
      imageUploadFile: null,
    };

    const initData = courseRelations.allSecernIds.reduce(
      (acc, userSecernId) => {
        // Step 11.0.0 START
        if (userList && userList[userSecernId]) {
          acc.checkedUser.allSecernIds.push(userSecernId);
          // Step 11.2.0 #17960 START
          const targetUserData = courseRelations.bySecernId[userSecernId];
          acc.editingUser[userSecernId] = targetUserData;
          acc.checkedUser.bySecernId[userSecernId] = targetUserData;
          // Step 11.2.0 #17960 END
          acc.editingUser[userSecernId] = initUserInfo(
            acc.editingUser[userSecernId], userList[userSecernId]);
          acc.checkedUser.bySecernId[userSecernId] = initUserInfo(
            acc.checkedUser.bySecernId[userSecernId], userList[userSecernId]);
        }
        // Step 11.0.0 END
        return acc;
      },
      {
        editingUser: {},
        checkedUser: {
          bySecernId: {},
          allSecernIds: [],
        },
      },
  );
    // Step 10.2.0 START
    const selectedItemList = [];
    if (itemListForCourseEnd) {
      for (let i = 0; i < itemListForCourseEnd.length; i++) {
        const newItemList = {
          itemSecernId: itemListForCourseEnd[i],
          addNew: true,
        };
        selectedItemList.unshift(newItemList);
      }
    }
    // Step 10.2.0 END
    return {
      ...state,
      editingCourse,
      searchUserCondition: { userType: USER_TYPE.STUDENT, userAttributeKeyNum: 1 },
      ...initData,
      childItemSercernIdList,
      selectedCourseGroupRelationList,
      // Step 10.2.0 START
      selectedItemList,
      detailSettingExpanded,
      userAttributeExpanded,
      // Step 10.2.0 END
    };
  }
  return {
    ...state,
  };
}

function initUserInfo(obj, objToAdd) {
  if (objToAdd) {
    obj.loginId = objToAdd.loginId;
    obj.userName = objToAdd.userName;
    obj.managementAuthoritySecernId = objToAdd.managementAuthoritySecernId;
    obj.userType = objToAdd.userType;
  }
  return obj;
}

function initDataForRegisterDialog(state, action) {
  const editingCourse = {
    ...INITIAL_COURSE,
    limitPublicPeriod: PUBLIC_PERIOD_TYPE.NO_LIMIT,
  };
  const checkedUser = {
    bySecernId: {},
    allSecernIds: [],
  };
  const editingUser = {};

  const checkedUserOnPage = {
    bySecernId: {},
    allSecernIds: [],
  };
  const { detailSettingExpanded, userAttributeExpanded } = INITIAL_STATE; // Step 10.2.0
  return {
    ...state,
    editingCourse,
    checkedUser,
    editingUser,
    checkedUserOnPage,
    editType: MODE.NEW_MODE,
    selectedCourseGroupRelationList: [],
    groupCourseRelationList: [],
    // Step 10.2.0 START
    detailSettingExpanded,
    userAttributeExpanded,
    // Step 10.2.0 END
  };
}

function receiveUserList(state, action) {
  const { userList } = action;
  const newState = userList.reduce(
    (acc, cur) => {
      // Step 11.2.0 #17960 START
      const { userSecernId } = cur;
      acc.userList[userSecernId] = cur;
      // Step 11.2.0 #17960 END
      return acc;
    }, {
      userList: {},
    },
  );
  return { ...state, ...newState };
}

function receiveCourseList(state, action) {
  const { recordNum, courseList } = action;
  const courses = courseList.reduce(
    (acc, cur) => {
      const { courseSecernId } = cur;
      const { bySecernId, allSecernIds } = acc;

      const notExistCourseSecernId = !hasProperty(bySecernId, courseSecernId);
      notExistCourseSecernId && allSecernIds.push(courseSecernId);
      bySecernId[courseSecernId] = cur;
      return acc;
    },
    {
      ...state.courses,
    },
  );

  return {
    ...state,
    ...{ courses },
  };
}

function receiveCourseRelation(state, action) {
  const { recordNum, courseRelationList } = action;

  const courseRelations = courseRelationList.reduce(
    (acc, cur) => {
      const { userSecernId } = cur;
      const { bySecernId, allSecernIds } = acc;

      allSecernIds.push(userSecernId);
      bySecernId[userSecernId] = cur;
      acc.recordNum = recordNum;
      return acc;
    },
    {
      recordNum,
      bySecernId: {},
      allSecernIds: [],
    },
  );

  return {
    ...state,
    ...{
      courseRelations,
    },
  };
}

function changeEditingData(state, action) {
  const { payload } = action;
  const { name, value } = payload;
  const editingCourse = { ...state.editingCourse, ...payload };
  return {
    ...state,
    editingCourse,
  };
}

function receiveSearchUserCondition(state, action) {
  const { payload } = action;
  return {
    ...state,
    searchUserCondition: { ...state.searchUserCondition, ...payload },
  };
}

function receiveUserSearchUserResult(state, action) {
  const { startPosition, recordNum, userList } = action;
  const { checkedUser } = state;
  const checkedUserOnPage = {
    bySecernId: {},
    allSecernIds: [],
  };
  const searchUserResult = userList.reduce(
    (acc, cur) => {
      const { userSecernId } = cur;
      acc.bySecernId[userSecernId] = cur;
      acc.allSecernIds.push(userSecernId);
      if (checkedUser && checkedUser.bySecernId) {
        if (checkedUser.bySecernId[userSecernId]) {
          checkedUserOnPage.allSecernIds.push(userSecernId);
          checkedUserOnPage.bySecernId[userSecernId] = cur;
        }
      }
      return acc;
    },
    { startPosition, searched: true, recordNum, bySecernId: {}, allSecernIds: [] },
  );
  return {
    ...state,
    searchUserResult,
    checkedUserOnPage,
  };
}

function addRemoveUser(state, action) {
  const { userSecernId } = action;
  const checkedUser = { ...state.checkedUser };
  const { searchUserResult, checkedUserOnPage } = state;
  if (searchUserResult
    && searchUserResult.allSecernIds
    && searchUserResult.allSecernIds.indexOf(userSecernId) > -1) {
    const posInList = checkedUser.allSecernIds.indexOf(userSecernId);
    if (posInList === -1) {
      checkedUser.allSecernIds.unshift(userSecernId);
    } else {
      checkedUser.allSecernIds.splice(posInList, 1);
    }
    if (checkedUser.bySecernId[userSecernId]) {
      delete checkedUser.bySecernId[userSecernId];
    } else {
      checkedUser.bySecernId[userSecernId] = searchUserResult.bySecernId[userSecernId];
    }
    const posInCheckedUserOnPage = checkedUserOnPage.allSecernIds.indexOf(userSecernId);
    if (posInCheckedUserOnPage === -1) {
      checkedUserOnPage.allSecernIds.unshift(userSecernId);
    } else {
      checkedUserOnPage.allSecernIds.splice(posInCheckedUserOnPage, 1);
    }
    if (checkedUserOnPage.bySecernId[userSecernId]) {
      delete checkedUserOnPage.bySecernId[userSecernId];
    } else {
      checkedUserOnPage.bySecernId[userSecernId] = searchUserResult.bySecernId[userSecernId];
    }
  }

  return {
    ...state,
    checkedUser,
  };
}

function addRemoveAllUser(state) {
  const checkedUser = { ...state.checkedUser };
  const { editingUser, searchUserResult } = state;
  let { checkedUserOnPage } = state;
  let newCheckedUsers = checkedUser;
  if (checkedUserOnPage.allSecernIds
    && searchUserResult.allSecernIds
    && checkedUserOnPage.allSecernIds.length === searchUserResult.allSecernIds.length) {
    newCheckedUsers = searchUserResult.allSecernIds.reduce((acc, userSecernId) => {
      if (!editingUser[userSecernId]) {
        if (acc.allSecernIds.indexOf(userSecernId) > -1) {
          const index = acc.allSecernIds.indexOf(userSecernId);
          acc.allSecernIds.splice(index, 1);
        }
        if (acc.bySecernId[userSecernId]) {
          delete acc.bySecernId[userSecernId];
        }
      }
      return acc;
    }, {
      bySecernId: checkedUser.bySecernId,
      allSecernIds: checkedUser.allSecernIds,
    });
    checkedUserOnPage = {
      bySecernId: {},
      allSecernIds: [],
    };
  } else {
    newCheckedUsers = searchUserResult.allSecernIds.reduce((acc, userSecernId) => {
      if (acc.allSecernIds.indexOf(userSecernId) < 0) {
        acc.allSecernIds.unshift(userSecernId);
      }
      if (!acc.bySecernId[userSecernId]) {
        acc.bySecernId[userSecernId] = searchUserResult.bySecernId[userSecernId];
      }
      if (checkedUserOnPage.allSecernIds.indexOf(userSecernId) < 0) {
        checkedUserOnPage.allSecernIds.unshift(userSecernId);
      }
      if (!checkedUserOnPage.bySecernId[userSecernId]) {
        checkedUserOnPage.bySecernId[userSecernId] = searchUserResult.bySecernId[userSecernId];
      }
      return acc;
    }, {
      bySecernId: checkedUser.bySecernId,
      allSecernIds: checkedUser.allSecernIds,
    });
  }
  return {
    ...state,
    checkedUser: newCheckedUsers,
    checkedUserOnPage,
  };
}

function addUserRelation(state, action) {
  const { courseRelations, checkedUser } = state;
  const editingUser = { ...state.editingUser };
  const usersToAdd = checkedUser.allSecernIds.reduce((acc, userSecernId, index) => {
    if (!checkedUser.bySecernId || !checkedUser.bySecernId[userSecernId]) {
      return acc;
    }
    let addNew = false;
    if (!editingUser[userSecernId]) {
      addNew = true;
    } else {
      addNew = editingUser[userSecernId].addNew;
    }
    // #7230 START
    const relationInfo = courseRelations.bySecernId[userSecernId] ||
    editingUser[userSecernId] || {
      userSecernId,
      attendingPeriodFrom: MIN_DATE_NO_SECOND,
      attendingPeriodTo: MAX_DATE_NO_SECOND,
    };
    // #7230 END
    relationInfo.addNew = addNew;
    const user = checkedUser.bySecernId[userSecernId];
    if (user) {
      relationInfo.userName = user.userName;
      relationInfo.loginId = user.loginId;
      relationInfo.managementAuthoritySecernId = user.managementAuthoritySecernId;
      relationInfo.userType = user.userType;
    }
    acc[userSecernId] = { ...relationInfo };
    editingUser[userSecernId] = acc[userSecernId];
    editingUser[userSecernId].index = index;
    return acc;
  }, {});

  return {
    ...state,
    editingUser,
  };
}

function removeUserRelation(state, action) {
  const { userSecernId } = action;
  const checkedUser = { ...state.checkedUser };
  const editingUser = { ...state.editingUser };
  const checkedUserOnPage = { ...state.checkedUserOnPage };
  const index = checkedUser.allSecernIds.indexOf(userSecernId);
  if (index > -1) {
    checkedUser.allSecernIds.splice(index, 1);
  }
  if (checkedUser.bySecernId[userSecernId]) {
    delete checkedUser.bySecernId[userSecernId];
  }
  const pos = checkedUserOnPage.allSecernIds.indexOf(userSecernId);
  if (pos > -1) {
    checkedUserOnPage.allSecernIds.splice(pos, 1);
  }
  if (checkedUserOnPage.bySecernId[userSecernId]) {
    delete checkedUserOnPage.bySecernId[userSecernId];
  }
  delete editingUser[userSecernId];

  return {
    ...state,
    editingUser,
    checkedUser,
    checkedUserOnPage,
  };
}

function removeAllUserRelation(state, action) {
  const { editingUser, checkedUser, checkedUserOnPage, editingCourse } = state;
  const { isAdminHasCourseRelation } = action;
  let bySecernId = {};
  let checkedUserRemove = {
    bySecernId: {},
    allSecernIds: [],
  };
  let checkedUserOnPageRemove = {
    bySecernId: {},
    allSecernIds: [],
  };
  if (isAdminHasCourseRelation) {
    bySecernId = { ...editingUser };
    const editingUserArray = Object.keys(bySecernId);
    editingUserArray.map((userSecernId) => {
      if (!bySecernId && !bySecernId[userSecernId]) {
        return null;
      }
      const {
        userType,
      } = bySecernId[userSecernId];
      if (parseInt(userType, 10) !== USER_TYPE.ADMIN) {
        delete bySecernId[userSecernId];
        checkedUserRemove = { ...checkedUser };
        const index = checkedUserRemove && checkedUserRemove.allSecernIds ?
        checkedUserRemove.allSecernIds.indexOf(userSecernId) : -1;
        if (index > -1) {
          checkedUserRemove.allSecernIds.splice(index, 1);
        }
        if (checkedUserRemove.bySecernId[userSecernId]) {
          delete checkedUserRemove.bySecernId[userSecernId];
        }
        checkedUserOnPageRemove = { ...checkedUserOnPage };
        const pos = checkedUserOnPageRemove && checkedUserOnPageRemove.allSecernIds ?
        checkedUserOnPageRemove.allSecernIds.indexOf(userSecernId) : -1;
        if (pos > -1) {
          checkedUserOnPageRemove.allSecernIds.splice(pos, 1);
        }
        if (checkedUserOnPageRemove.bySecernId[userSecernId]) {
          delete checkedUserOnPageRemove.bySecernId[userSecernId];
        }
      }
    });
  }
  return {
    ...state,
    editingUser: bySecernId,
    checkedUser: checkedUserRemove,
    checkedUserOnPage: checkedUserOnPageRemove,
  };
}

function editPeriodTime(state, action) {
  const { userSecernId, payload } = action;
  const user = { ...state.editingUser[userSecernId], ...payload };
  return {
    ...state,
    editingUser: {
      ...state.editingUser,
      [userSecernId]: user,
    },
  };
}

function changeEditType(state, action) {
  const { editType } = action;
  const searchUserCondition = { userType: USER_TYPE.STUDENT, userAttributeKeyNum: 1 };
  return {
    ...state,
    searchUserCondition,
    editType,
  };
}

function resetInitData(state) {
  const {
    courseRelations,
    searchUserResult,
    searchUserCondition,
    editType,
    editingUser,
    editingCourse,
    checkedUser,
    checkedUserOnPage,
  } = INITIAL_STATE;

  return {
    ...state,
    courseRelations,
    searchUserResult,
    searchUserCondition,
    editingUser,
    editingCourse,
    checkedUser,
    checkedUserOnPage,
  };
}

function changeData(state) {
  const { courses } = state;
  const { bySecernId } = courses;
  try {
    const courseSecernId = state.editingCourse.courseSecernId;
    let thumbnailUrl = null;
    if (bySecernId && bySecernId[courseSecernId] && bySecernId[courseSecernId].thumbnailUrl) {
      if (state.editingCourse.imageFileSelectType === CHOSEN_THUMBNAIL.NOTHING) {
        thumbnailUrl = bySecernId[courseSecernId].thumbnailUrl;
      }
    }
    const editingCourse = {
      ...state.editingCourse,
      thumbnailUrl,
    };
    return {
      ...state,
      editingCourse,
    };
  } catch (err) {
    return err;
  }
}

function getThumbnailDefault(state, action) {
  const { data } = action;
  let defaultThumbnail = null;
  try {
    if (data && data.imageList && data.imageList.length && data.imageList[0].thumbnailUrl) {
      defaultThumbnail = data.imageList[0].thumbnailUrl;
    }
  } catch (err) {
    return err;
  }
  const editingCourse = {
    ...state.editingCourse,
    defaultThumbnail,
  };
  return {
    ...state,
    editingCourse,
  };
}

function getUserCourseRelation(state, action) {
  const { data } = action;
  const editingCourse = {
    ...state.editingCourse,
    recordNumUserCourseRelation: data,
  };
  return {
    ...state,
    editingCourse,
  };
}


function addCourseGroupRelation(state, action) {
  const selectedCourseGroupRelationList = [...state.selectedCourseGroupRelationList];
  const groupCourseRelationList = [...state.groupCourseRelationList];
  const { group } = action;
  // Collect selected group id
  const selectedIds = selectedCourseGroupRelationList.reduce((ids, cur) => {
    ids.push(cur.groupSecernId);
    return ids;
  }, []);

  // Collect group id from detail.
  const groupCourseIds = groupCourseRelationList.reduce((ids, curr) => {
    ids.push(curr.groupSecernId);
    return ids;
  }, []);
  for (let i = 0; i < group.length; i++) {
    if (selectedIds.indexOf(group[i]) === -1) {
      // #7230 START
      const newGroup = {
        groupSecernId: group[i],
        attendingPeriodFrom: MIN_DATE_NO_SECOND,
        attendingPeriodTo: MAX_DATE_NO_SECOND,
        addNew: true,
      };
      // #7230 END
      // Check exist in list of course group get from detail.
      if (groupCourseIds.indexOf(group[i]) !== -1) {
        newGroup.addNew = false;
      }
      selectedCourseGroupRelationList.unshift(newGroup);
    }
  }
  return {
    ...state,
    selectedCourseGroupRelationList,
  };
}

function removeCourseGroupRelation(state, action) {
  const selectedCourseGroupRelationList = [...state.selectedCourseGroupRelationList];
  const { index } = action;
  const maxIndex = selectedCourseGroupRelationList[0].index;
  selectedCourseGroupRelationList.splice(index, 1);

  return {
    ...state,
    selectedCourseGroupRelationList,
  };
}

function removeAllCourseGroupRelation(state, action) {
  const { isAdminHasCourseRelation } = action;
  const { selectedCourseGroupRelationList } = state;
  const newArray = [...selectedCourseGroupRelationList];
  let selectedCourseGroupRelationListNew = [];
  if (newArray && newArray.length) {
    selectedCourseGroupRelationListNew = newArray.reduce((acc, cur) => {
      if (cur.courseGroupRelationType === COURSE_GROUP_RELATION_TYPE.INDIRECT ||
          (cur.courseGroupRelationType === COURSE_GROUP_RELATION_TYPE.DIRECT && !cur.addNew && isAdminHasCourseRelation)) {
        acc.push(cur);
      }
      return acc;
    }, []);
  }
  return {
    ...state,
    selectedCourseGroupRelationList: selectedCourseGroupRelationListNew,
  };
}

function editGroupPeriodTime(state, action) {
  const { index, payload } = action;
  const selectedCourseGroupRelationList = [...state.selectedCourseGroupRelationList];
  const group = { ...state.selectedCourseGroupRelationList[index], ...payload };
  selectedCourseGroupRelationList[index] = group;
  return {
    ...state,
    selectedCourseGroupRelationList,
  };
}

function receiveGroupCourseSearchResult(state, action) {
  const { startPosition, recordNum, data } = action;
  const { courseRelationList } = data;
  let { selectedCourseGroupRelationList } = state;

  const courseGroupRelationList = courseRelationList.reduce((acc, cur) => {
    acc.push({
      groupSecernId: cur.groupSecernId,
      courseSecernId: cur.courseSecernId,
      courseGroupRelationType: cur.courseGroupRelationType,
      attendingPeriodFrom: cur.attendingPeriodFrom,
      attendingPeriodTo: cur.attendingPeriodTo,
    });
    return acc;
  }, []);

  selectedCourseGroupRelationList = [...courseGroupRelationList];
  return {
    ...state,
    groupCourseRelationList: courseRelationList,
    selectedCourseGroupRelationList,
    recordNumGroupCourseRelation: data.recordNum,
  };
}

// Step 10.2.0 START
function saveDetailSettingState(state, action) {
  const { name, value } = action;
  return {
    ...state,
    [name]: value,
  };
}
// Step 10.2.0 END

